type LogoutVisitOptions = {
  onStart: () => void;
};

type LogoutRouter = {
  post(url: string, data: undefined, options: LogoutVisitOptions): void;
};

/**
 * A browser that blocks site data throws `SecurityError` on storage access. That storage holds no
 * data, so logout continues.
 */
function clearStorage(getStorage: () => Storage): void {
  try {
    getStorage().clear();
  } catch (error) {
    if (error instanceof DOMException && error.name === 'SecurityError') {
      return;
    }

    throw error;
  }
}

function clearBrowserStorage(): void {
  if (window.isPreviewing) {
    return;
  }

  clearStorage(() => window.localStorage);
  clearStorage(() => window.sessionStorage);
}

/**
 * Mirrors the `Clear-Site-Data` header of the logout response for browsers that ignore it. Storage
 * is cleared only when the request starts, because the page playground router blocks the request.
 * A page editor preview keeps storage, because it shares the editor's origin but not its session.
 * Clearing session storage also removes Inertia's history encryption key, so earlier history
 * entries cannot be decrypted.
 */
export function logoutCurrentUser(router: LogoutRouter): void {
  router.post('/logout', undefined, { onStart: clearBrowserStorage });
}
